/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { IsItemGreyedOut_ItemFragmentDoc } from '../doc-items/helpers.generated.js';
import { VirtualItem__DocumentItemFragmentDoc } from '../../trees-virtual/types.generated.js';
export type DocDataGrid_ItemFragment = { __typename: 'Item', id: string, parentId?: string | null, type: Types.ItemType, isRootItem: boolean, hasChildren: boolean, rank: number, deletedAt?: any | null, pathForPdf: string, title: string, authorOrganisationId: string, isAnyParentItemEliminated: boolean, isItemEliminated: boolean, decisionIsContingentItem: boolean, decisionContingentItemPreselection?: boolean | null, needsAgreement: boolean, decisionOptionBehaviour: Types.DecisionBehaviorOfSubitems, decisionOptionIsPreselected?: boolean | null, binding: Types.ItemBinding, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, level: number, pathSortable: string, linkedQuoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null } | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null };

export const DocDataGrid_ItemFragmentDoc = gql`
    fragment DocDataGrid_Item on Item {
  id
  parentId
  type
  isRootItem
  hasChildren
  rank
  deletedAt
  linkedQuoteTemplate {
    id
    resolvedAsReadModelVersionNumber
  }
  pathForPdf
  title
  authorOrganisationId
  isAnyParentItemEliminated
  isItemEliminated
  decisionOptionElimination {
    reason
  }
  decisionIsContingentItem
  decisionContingentItemPreselection
  needsAgreement
  decisionOptionBehaviour
  decisionOptionIsPreselected
  ...IsItemGreyedOut_Item
  binding
  isHidden
  isPriceHidden
  isParentDecisionPreselected
  isParentDecisionNotPreselected
  isParentContingencyNotPreselected
  decisionSubitemsPreselection
  decisionBehaviorOfSubitems
  isExplicitHidden
  childrenVisibility
  ...VirtualItem__DocumentItem
}
    ${IsItemGreyedOut_ItemFragmentDoc}
${VirtualItem__DocumentItemFragmentDoc}`;